<template>
  <div class="miniBTC">
    
    <Headers :windowWidth="windowWidth" />
    <div class="mini_bg">
      <div class="continer_width">
        <el-row :gutter="20">
          <el-col :span="15">
            <div class="grid-content bg-purple">
              <div class="bg_title">
                <!-- {{login.country ? login.country + ' National ' : 'MetaVerse Green'}} -->
                 {{ $t("chinaCarbonIndex.bg_title") }}<br>
                 {{ $t("chinaCarbonIndex.bg_title_t") }}
              </div>
              <div class="xian"></div>
              <div class="Specs">
                {{ $t("carbonIndex.tips") }}
              </div>
            </div>
            
          </el-col>
          <el-col :span="9">
            <div class="grid-content bg-purple">
              <img src="../../assets/img/bg_tu.png" alt="" class="bg_tu" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <!-- tab切换 -->
    <!-- <div class="tab_bg">
      <el-row type="flex" justify="space-between" class="continer_width">
        <el-col>
          <span
            class="tab_item"
            :class="index == 1 ? 'tab_sel' : ''"
            @click="tab(1)"
          >
            {{ $t("carbonIndex.Carbon_Credit_Registry") }}
          </span>
          <span class="tab_item" :class="index == 2 ? 'tab_sel' : ''">
            {{ $t("carbonIndex.Carbon_Footprint_Registry") }}
          </span>
          <span class="tab_item" :class="index == 3 ? 'tab_sel' : ''">
            {{ $t("carbonIndex.Carbon_Neutrality_Registry") }}
          </span>
          <span class="tab_item" :class="index == 4 ? 'tab_sel' : ''">
            {{ $t("carbonIndex.Carbon_Reporting") }}
          </span>
        </el-col>
      </el-row>
    </div> -->
    
    <!-- content -->
    <div class="mini_content continer_width m_100" >
      <el-row type="flex" justify="space-between" :gutter="40">
        <!-- 左侧 -->
        <el-col :span="12" class="left">
          
          <el-collapse v-model="activeName" @change="handleChange" accordion>
            <el-collapse-item
              :class="{ aaa: currentActiveName == 1 }"
              :title="$t('chinaCarbonIndex.collapse_one_title')"
              name="1"
            >
              <!-- <div>
                <ul class="Country1">
                  <li
                    @click="changeOverview(1)"
                    :class="sel == 1 ? 'overviewSel' : ''"
                  >
                    - {{ $t("carbonIndex.Registry_Carbon_Projects") }}
                  </li>
                  <li
                    @click="changeOverview(2)"
                    :class="sel == 2 ? 'overviewSel' : ''"
                  >
                    - {{ $t("carbonIndex.Registry_Carbon_Credits") }}
                  </li>
                </ul>
              </div> -->
            </el-collapse-item>
            <el-collapse-item
              :class="{ aaa: currentActiveName == 2 }"
              :title="$t('chinaCarbonIndex.collapse_two_title')"
              name="2"
            >
              <!-- <div class="Tokenize">
                <el-collapse v-model="active" @change="handleChangeProject" accordion class="one">
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Initiate_New_Projects')" name="1">
                  </el-collapse-item>
                  
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Credits_Adjustments')" name="2">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Generate_CNTs')" name="3">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Generate_C_CNTs')" name="4">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Tokenize')" name="5">
                    <div class="projects">
                <el-form class="form">
                  <el-form-item :label="$t('carbonIndex.ID')">
                    <el-input v-model="form.projectSiteId" min="0"  oninput="value=value.replace(/[^\d.]/g,'')" ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('carbonIndex.NAME')">
                    <el-input v-model="form.projectName"></el-input>
                  </el-form-item>
                  <el-collapse v-model="activeNames">
                    <el-collapse-item
                      :title="$t('carbonIndex.Project_Type')"
                      name="1"
                    >
                      <div>
                        <ul class="Country">
                          <li
                            :class="typeSel == index ? 'overviewSel selbg' : ''"
                            @click="changeType(index)"
                            v-for="(item, index) in typeList"
                            :key="index"
                          >
                            - {{ item }}
                          </li>
                        </ul>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item
                      :title="$t('carbonIndex.Methodology')"
                      name="2"
                    >
                      <div>
                        <ul class="Country">
                          <li
                            :class="
                              methodologySel == index ? 'overviewSel selbg' : ''
                            "
                            @click="changeMethodology(index)"
                            v-for="(item, index) in methodologyList"
                            :key="index"
                          >
                            - {{ item }}
                          </li>
                        </ul>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item
                      v-if="login.type == 1"
                      :title="login.currncy ? login.currncy : $t('carbonIndex.Country')"
                      name="3"
                    >
                      <div>
                        <ul class="Country">
                          <li
                            :class="countrySel == index ? 'overviewSel selbg' : ''"
                            @click="changeCountry(index)"
                            v-for="(item, index) in countryList"
                            :key="index"
                          >
                            - {{ item }}
                          </li>
                        </ul>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item
                      v-if="login.type == 2"
                      :title="login.currncy ? login.currncy : $t('carbonIndex.province')"
                      name="3"
                    >
                      <div class="Country">
                        <el-checkbox-group v-model="provinceStateSel" >
                          <el-checkbox v-for="(item, index) in provinceState" :key="index" :label="item">- {{item}}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                  <div class="display_flex bth-wrap">
                    <el-button class="bths bthClear" @click="clearSearch">{{
                      $t("carbonIndex.Reset_Search")
                    }}</el-button>
                    <el-button class="bths" @click="search">{{
                      $t("carbonIndex.Search")
                    }}</el-button>
                  </div>
                </el-form>
              </div>
                  </el-collapse-item>
                  
                  
                </el-collapse>
              </div> -->
            </el-collapse-item>
            <el-collapse-item
              :class="{ aaa: currentActiveName == 3 }"
              :title="$t('chinaCarbonIndex.collapse_three_title')"
              name="3"
            >
              <!-- <div class="Tokenize ">
                <el-collapse v-model="creditssel" @change="changeCreditsSel" accordion class=" three">
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_one')" name="1">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_two')" name="2">
                    <div class="Tokenize TokenizeCarbon">
                      <el-collapse v-model="tokenCarbonSel" @change="changeTokenCarbonSel" accordion class="one">
                        <el-collapse-item :title="'- '+ $t('carbonIndex.three_Token_National')" name="1">
                        </el-collapse-item>
                        <el-collapse-item :title="'- '+ $t('carbonIndex.three_Token_Neutrality')" name="2">
                        </el-collapse-item>
                        <el-collapse-item :title="'- '+ $t('carbonIndex.three_token_compliance')" name="3">
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_three')" name="3">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_four')" name="4">
                  </el-collapse-item>
                </el-collapse>
              </div> -->

            </el-collapse-item>
            <el-collapse-item
              :class="{ aaa: currentActiveName == 4 }"
              :title="$t('chinaCarbonIndex.collapse_four_title')"
              name="4"
            >
              <!-- <ul class="Country1">
                <li
                  @click="changeTransactions(1)"
                  :class="transactionsSel == 1 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.OwnershipTrades") }}
                </li>
                <li
                  @click="changeTransactions(2)"
                  :class="transactionsSel == 2 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Corresponding_Adjustments") }}
                </li>
                <li
                  @click="changeTransactions(3)"
                  :class="transactionsSel == 3 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Domestic") }}
                </li>
                <li
                  @click="changeTransactions(4)"
                  :class="transactionsSel == 4 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Permanent") }}
                </li>
                <li
                  @click="changeTransactions(5)"
                  :class="transactionsSel == 5 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Cancel_Carbon") }}
                </li>
              </ul> -->
            </el-collapse-item>
          </el-collapse>
          
          <!-- <div class="logOut">{{$t('carbonIndex.logOUt')}}</div> -->
        </el-col>
        <!-- 右侧 -->
        <el-col>
          <div class="overview_wrap" v-if="currentActiveName == 1">
            <div class="" >
                <el-row>
                  <div class="title">
                    {{$t('chinaCarbonIndex.collapse_one_title_con_title')}}
                  </div>
                </el-row>
                <el-row>
                  <div class="Tokenize_title">
                    {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader')}}
                  </div>
                </el-row>
                <el-row>
                  <ul>
                    <li class="Tokenize_title_item">
                      <span style="font-weight:bold;color:#1E1E1E">
                        {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_oneItem_bold')}}
                      </span>
                       {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_oneItem')}}
                    </li>
                    <li class="Tokenize_title_item">
                      <span style="font-weight:bold;color:#1E1E1E">
                        {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_twoItem_Convert')}}
                      </span>
                       {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_twoItem_regis')}}
                      <span style="font-weight:bold;color:#1E1E1E">
                        {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_twoItem_CNT')}};
                      </span>
                       {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_twoItem_and')}}
                    </li>
                    <li class="Tokenize_title_item">
                      <span style="font-weight:bold;color:#1E1E1E">
                        {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_threeItem_list')}}
                      </span>
                      {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_twoItem_and')}}
                      <span style="font-weight:bold;color:#1E1E1E">
                        {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_threeItem_trade')}}
                      </span>
                       {{$t('chinaCarbonIndex.collapse_one_title_con_title_oHeader_threeItem')}}
                    </li>
                  </ul>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <div class="Tokenize_title">
                    {{$t('chinaCarbonIndex.collapse_one_title_con_title_twoHeader')}}
                  </div>
                </el-row>
                <el-row>
                  <el-row type="flex" justify="space-between" class="one">
                    <el-col class="name">{{$t('chinaCarbonIndex.collapse_one_title_con_title_twoHeader_oneItem')}}</el-col>
                    <el-col class="name nums num" :span="8">1,200,000</el-col>
                  </el-row>
                  <el-row type="flex" justify="space-between" class="one">
                    <el-col class="name">{{$t('chinaCarbonIndex.collapse_one_title_con_title_twoHeader_twoItem')}}</el-col>
                    <el-col class="name nums num" :span="8" >900,000</el-col>
                  </el-row>
                  <el-row type="flex" justify="space-between" class="one">
                    <el-col class="name">{{$t('chinaCarbonIndex.collapse_one_title_con_title_twoHeader_threeItem')}}</el-col>
                    <el-col class="name nums num" :span="8">850,000</el-col>
                  </el-row>
                </el-row>
            </div>
          </div>
          <div v-if="currentActiveName == 2">
            <div
              class="threeWrap"
            >
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    <span v-if="!listShow">{{ $t("chinaCarbonIndex.collapse_two_title_con_title") }}</span>
                    <span v-if="listShow">{{ $t("chinaCarbonIndex.ccer_credits_information") }}</span>
                  </div>
                </el-row>
                <el-form v-if="!listShow">
                  <el-row type="flex" :gutter="20">
                    <el-col>
                      <el-form-item :label="$t('chinaCarbonIndex.Project_CCER_ID')">
                        <el-input placeholder="Please Enter" v-model="form.projectCcerId"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item :label="$t('chinaCarbonIndex.Project_Name')">
                        <el-input placeholder="Please Enter" v-model="form.projectName"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row type="flex" :gutter="20">
                    <el-col>
                      <el-form-item :label="$t('chinaCarbonIndex.Credits_for_CNTs_Conversion')">
                        <el-input placeholder="Please Enter" v-model="form.creditsConversion"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item :label="$t('chinaCarbonIndex.CCER_Custodian')">
                        <el-input placeholder="Please Enter" v-model="form.ccerCredits"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row type="flex" :gutter="20">
                    <el-col>
                      <el-form-item :label="$t('chinaCarbonIndex.CNT_Issuer')">
                        <el-input placeholder="Please Enter" v-model="form.issuer"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      
                    </el-col>
                  </el-row>
                </el-form>
                <!-- table表格 -->
                <div v-if="listShow">
                    <el-table
                      :data="
                        tableData.slice(
                          (currentPage - 1) * pageSize,
                          currentPage * pageSize
                        )
                      "
                      stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      :cell-style="columnStyle"
                      style="width: 100%"
                    >
                      <!-- 空状态 -->
                      <template slot="empty">
                        <p style="margin-top: 50px">
                          <img
                            class="data-pic"
                            src="../../assets/img/noData.png"
                            alt=""
                          />
                        </p>
                        <p class="nodata">{{ $t("carbonIndex.noData") }}</p>
                      </template>
                      <el-table-column prop="projectCcerId"  :label="$t('chinaCarbonIndex.Project_CCER_ID')">
                      </el-table-column>
                      <el-table-column prop="projectName"  :label="$t('chinaCarbonIndex.Project_Name')">
                      </el-table-column>
                      <el-table-column
                        prop="creditsConversion"
                        :label="$t('chinaCarbonIndex.Credits_for_CNTs_Conversion')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="ccerCredits"
                        :label="$t('chinaCarbonIndex.CCER_Custodian')"
                        v-if="login.type == 1"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="issuer"
                        :label="$t('chinaCarbonIndex.CNT_Issuer')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="registryId"
                        :label="$t('chinaCarbonIndex.Credits_Registry_ID')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="projectAddress"
                        :label="$t('chinaCarbonIndex.Project_NFDT_Address')"
                      >
                      </el-table-column>
                    </el-table>
                </div>
              
                <el-row>
                  <div class="title" style="margin-top:60px">
                    {{ $t("chinaCarbonIndex.Upload_CCER") }}
                  </div>
                </el-row>
                <el-row type="flex" v-if="!listShow" justify="space-between">
                  <el-col>
                    <el-button class="btn_wrap">
                      <img src="../../assets/img/xia.png" alt="">
                      {{$t('chinaCarbonIndex.Upload_Certificates')}}
                    </el-button>
                  </el-col>
                  <el-col style="text-align:right">
                    <el-button class="btn_wrap btn_submit" @click="submit">
                      {{$t('chinaCarbonIndex.submit')}}
                    </el-button>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center" :gutter="40" v-if="listShow">
                  <el-col style="text-align:right">
                    <img src="../../assets/img/purchase.png" alt="">
                  </el-col>
                  <el-col>
                    <img src="../../assets/img/purchase.png" alt="">
                  </el-col>
                </el-row>
              </div>
            </div>
            
          </div>
          <div v-if="currentActiveName == 3">
            <div
              class="threeWrap"
            >
              <div class="overview_wrap" v-if="!convertShow">
                <el-row type="flex" justify="space-between">
                  <el-col>
                    <div class="selects">
                      {{ $t("chinaCarbonIndex.Selects_Credits_from_Registered_Projects") }}
                    </div>
                  </el-col>
                  <el-col class="convertWrap">
                    <el-collapse v-model="activeNames" @change="handleChangeType" accordion>
                      <el-collapse-item
                        :title="$t('chinaCarbonIndex.select_project_id')"
                        name="1"
                      >
                        <div>
                          <ul class="Country">
                            <!--  -->
                            <li
                              @click="changeType(index)"
                              :class="typeSel == index ? 'overviewSel selbg' : ''"
                              v-for="(item,index) in projectIdList" :key="index"
                            >
                              - {{item}}
                            </li>
                          </ul>
                        </div>
                      </el-collapse-item>
                      <el-collapse-item
                        :title="$t('chinaCarbonIndex.select_NFDT')"
                        name="2"
                      >
                        <div>
                          <ul class="Country ">
                            <!--  -->
                            <li
                              @click="changenfdt(index)"
                              style="word-break: break-all;"
                              v-for="(item,index) in nfdtList" :key="index"
                              :class="nfdtSel == index ? 'overviewSel selbg' : ''"
                            >
                              - {{item}}
                            </li>
                          </ul>
                        </div>
                      </el-collapse-item>
                  </el-collapse>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row type="flex" justify="space-between">
                  <el-col>
                    <div class="selects">
                      {{ $t("chinaCarbonIndex.enter_number") }}
                    </div>
                  </el-col>
                  <el-col class="convertWrap">
                    <el-input v-model="numberConverted"></el-input>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col>
                    <el-button class="btn_wrap btn_submit" @click="selSubmit">{{$t('chinaCarbonIndex.submit')}}</el-button>
                  </el-col>
                </el-row>
              </div>
              <div class="overview_wrap" v-if="convertShow">
                <el-row>
                  <div class="title title_little">
                    {{ $t("chinaCarbonIndex.your_request") }} <b>{{addComma(numberConverted)}}</b>
                    {{$t('chinaCarbonIndex.ccer_credits')}}
                  </div>
                </el-row>
                <el-row>
                  <div class="title"  style="margin-top:80px">
                    {{ $t("chinaCarbonIndex.title_li") }}
                  </div>
                </el-row>
                <!-- table表格 -->
                <div >
                    <el-table
                      :data="
                        convertCCERList
                      "
                      stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      :cell-style="columnStyle"
                      style="width: 100%"
                    >
                      <!-- 空状态 -->
                      <template slot="empty">
                        <p style="margin-top: 50px">
                          <img
                            class="data-pic"
                            src="../../assets/img/noData.png"
                            alt=""
                          />
                        </p>
                        <p class="nodata">No Data</p>
                      </template>
                      <el-table-column prop="id"  :label="$t('chinaCarbonIndex.Project_CCER_ID')">
                      </el-table-column>
                      <el-table-column prop="projectName"  :label="$t('chinaCarbonIndex.Project_Name')">
                      </el-table-column>
                      <el-table-column
                        prop="cnts"
                        :label="$t('chinaCarbonIndex.Credits_Converted_for_CNTs')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="issuer"
                        :label="$t('chinaCarbonIndex.CNT_Issuer')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="registryId"
                        :label="$t('chinaCarbonIndex.Credits_Registry_ID')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="address"
                        :label="$t('chinaCarbonIndex.Project_NFDT_Address')"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="cntAddress"
                        :label="$t('chinaCarbonIndex.CNT_Address')"
                      >
                      </el-table-column>
                    </el-table>
                </div>
              
              </div>
            </div>
          </div>

          <div class="overview_wrap" v-if="currentActiveName == 4">
              <div v-if="!cntsShow">
                <el-row type="flex" justify="space-between">
                  <el-col>
                    <div class="selects">
                      {{ $t("chinaCarbonIndex.Selects_CNTs_to_List") }}
                    </div>
                  </el-col>
                  <el-col class="convertWrap">
                    <el-collapse v-model="cntsactiveName" accordion>
                      <el-collapse-item
                        :title="$t('chinaCarbonIndex.select_project_id')"
                        name="1"
                      >
                        <div>
                          <ul class="Country">
                            <!--  -->
                            <li
                              :class="refistryIdSel == index ? 'overviewSel selbg' : ''"
                              @click="changeRefistryId(index)"
                              v-for="(item,index) in creditList" :key="index"
                            >
                              - {{item}}
                            </li>
                          </ul>
                        </div>
                      </el-collapse-item>
                      <el-collapse-item
                        :title="$t('chinaCarbonIndex.CNT_Address_sel')"
                        name="2"
                      >
                        <div>
                          <ul class="Country ">
                            <!--   -->
                            <li
                              style="word-break: break-all;"
                              :class="cntAddressSel == index ? 'overviewSel selbg' : ''"
                              @click="changecnt(index)"
                               v-for="(item,index) in cntAddressList" :key="index"
                            >
                              - {{item}}
                            </li>
                          </ul>
                        </div>
                      </el-collapse-item>
                  </el-collapse>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row type="flex" justify="space-between">
                  <el-col>
                    <div class="selects">
                      {{ $t("chinaCarbonIndex.Enter_Number_of_CNTs_to_List") }}
                    </div>
                  </el-col>
                  <el-col class="convertWrap">
                    <el-input v-model="cntsNumber"></el-input>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col>
                    <el-button class="btn_wrap btn_submit" style="width:300px" @click="ListingSubmit">{{$t('chinaCarbonIndex.Submit_Listing_Documents_to_MVGX')}}</el-button>
                  </el-col>
                </el-row>
              </div>

              <div v-if="cntsShow">
                <el-row>
                  <div class="title" style="margin-bottom:20px">
                    {{$t('chinaCarbonIndex.Status_CNTs_on_MVGX')}}
                  </div>
                </el-row>
                <el-row>
                  <div class="cntid">
                    {{$t('chinaCarbonIndex.cntId')}} 
                    <span>0x57693e4356g ...</span>
                  </div>
                </el-row>

                <el-row class="steps">
                  <el-col>
                    <el-steps :active="steps" align-center finish-status="success">
                      <el-step :description="$t('chinaCarbonIndex.steps_one')"></el-step>
                      <el-step :description="$t('chinaCarbonIndex.steps_two')"></el-step>
                      <el-step :description="$t('chinaCarbonIndex.steps_three')"></el-step>
                      <el-step :description="$t('chinaCarbonIndex.steps_four')"></el-step>
                  </el-steps>
                  </el-col>
                </el-row>
                
                <el-row type="flex"  class="step" :gutter="40" align="middle">
                  <el-col>
                    <div class="step_nums">{{$t('chinaCarbonIndex.step_one')}}</div>
                    <div>{{$t('chinaCarbonIndex.step_one_content')}}</div>
                  </el-col>
                  <el-col :span="18">
                    <span class="complete">{{$t('chinaCarbonIndex.step_Complete')}}</span>
                  </el-col>
                </el-row>
                <el-row type="flex" class="step" :gutter="40" align="middle">
                  <el-col>
                    <div class="step_nums">{{$t('chinaCarbonIndex.step_two')}}</div>
                    <div>{{$t('chinaCarbonIndex.step_two_content')}}</div>
                  </el-col>
                  <el-col :span="18">
                    <span class="complete">{{$t('chinaCarbonIndex.step_Complete')}}</span>
                    <el-button class="btn_wrap">{{$t('chinaCarbonIndex.View_Listing_Docs')}}</el-button>
                  </el-col>
                </el-row>
                <el-row type="flex" class="step" :gutter="40" align="middle">
                  <el-col>
                    <div class="step_nums">{{$t('chinaCarbonIndex.step_three')}}</div>
                    <div>{{$t('chinaCarbonIndex.step_three_content')}}</div>
                  </el-col>
                  <el-col :span="18">
                    <span class="complete">{{$t('chinaCarbonIndex.step_Complete')}}</span>
                    <el-button class="btn_wrap">{{$t('chinaCarbonIndex.View_Approval_Notice')}}</el-button>
                  </el-col>
                </el-row>
                <el-row type="flex" class="step step_four" :gutter="40" align="middle" >
                  <el-col>
                    <div class="step_nums">{{$t('chinaCarbonIndex.step_four')}}</div>
                    <div>{{$t('chinaCarbonIndex.step_four_content')}}</div>
                  </el-col>
                  <el-col :span="18">
                    <span class="complete">{{$t('chinaCarbonIndex.Pending')}}</span>
                  </el-col>
                </el-row>
                
              </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Headers from "@/components/header/index.vue";
import MAPS from "@/components/map/index.vue"
import carbonRegistry from "@/api/carbonRegistry.js";
import { formatDate, formatDateTime } from "@/util/date";
export default {
  components: { Headers , MAPS },
  data() {
    return {
      index: 1,
      activeName: "1",
      activeNames: '',
      pageSize: 10,
      currentPage: 1,
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      tableData: [],
      sel: 1,
      form: {
        projectCcerId: "",
        projectName: "",
        creditsConversion:'',
        ccerCredits:'',
        issuer:'',
        registryId:'001',
        projectAddress:'--'
      },
      countryList: [],
      countrySel: null,
      provinceStateSel:[],
      typeList: [],
      typeSel: null,
      nfdtSel:null,
      methodologyList: [],
      methodologySel: null,
      currentActiveName: "1",
      creditssel: null,
      transactionsSel: null,
      active:'',
      creditsSel:null,
      labelPosition:'top',
      data:{
        objective:"",
        name:'',
        country:"",
        developer:'',
        standards:'',
        period:'',
        qualification:'',
        type:'',
        state:'',
        verifier:'',
        methodology:'',
        credits:'',
      },
      login:{},
      provinceState:[],
      ConbonList:[
        {
          projectId:"528",
          projectName:'Huang Gai Chuo200 MW Wind Farm, Zhangjiakou, Hebei, China',
        },
        {
          date:"2022.06.03 14:25",
          BuyerId:'1003',
          sellId:'1001',
          type:'Tokenized',
          Transaction:'2,000',
          projectId:"--"
        },
        {
          date:"2022.06.03 14:29",
          BuyerId:'1003',
          sellId:'1355',
          type:'Tokenized',
          Transaction:'5,000',
          projectId:"--"
        },
        {
          date:"2022.06.03 15:25",
          BuyerId:'1002',
          sellId:'1455',
          type:'Traditional',
          Transaction:'2,500',
          projectId:"395"
        },
        {
          date:"2022.06.03 15:30",
          BuyerId:'1009',
          sellId:'1001',
          type:'Traditional',
          Transaction:'1,000',
          projectId:"850"
        },
      ],
      tokenCarbonSel:null,
      listShow:false,
      convertShow:false,
      cntsShow:false,
      steps:3,
      projectIdList:[],
      nfdtList:[],
      numberConverted:'',
      creditList:['001','002','003'],
      cntsactiveName:'',
      cntAddressList:['0x47698d3254fafb0','7cf69a0f1e84c7ed770','66cbe051c4b78e84c7'],
      cntAddressSel:'',
      refistryIdSel:'',
      cntsNumber:'',
      convertCCERList:[{
        id:'528',
        projectName:'Huang Gai Chuo200 MW Wind Farm, Zhangjiakou, Hebei, China',
        cnts:'10,000',
        issuer:'MetaVerse Green Exchange (MVGX)',
        registryId:'001',
        address:'--',
        cntAddress:'--'
      }]
    };
  },
  mounted() {
    let that = this;
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        that.windowWidth = document.documentElement.clientWidth, //实时屏幕宽度
        that.windowHeight = window.fullHeight; // 高
      })();
    };
    // if(JSON.parse(sessionStorage.getItem('form'))){
    //   let form = JSON.parse(sessionStorage.getItem('form'))
    //   this.tableData.push(form)
    // }
    that.getprojectId()
    
  },
  beforeRouteEnter(to, from, next) {
    if(from.name == 'Home'){
      to.meta.keepAlive = true;
      to.meta.isBack = true;
    } // 当从上个页面corporateInfo返回当前页面时，不刷新当前页面
     next();
  },
  // 注意activated只能在keep-alive组件中调用
  activated() {
        if(!this.$route.meta.isBack == false){
              // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
              this.$router.go(0)  //刷新当前页面
        }
        // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
        this.$route.meta.isBack=false
  },
  methods: {
    formatDate: formatDate,
    submit(){
      // sessionStorage.setItem('form',JSON.stringify(this.form))
      this.listShow = true
      this.tableData.push({
        projectCcerId: this.form.projectCcerId,
        projectName: this.form.projectName,
        creditsConversion:this.form.creditsConversion,
        ccerCredits:this.form.ccerCredits,
        issuer:this.form.issuer,
        registryId:'001',
        projectAddress:'--'
      })
      
    },
    // 定义添加逗号的方法
    addComma(num = 0) {
        return num.toString().replace(/\d+/, function(n) {
            return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        });
    },
    submitProjectInfo(){
      
    },
    selSubmit(){
      // let data = {
      //   projectSiteId:this.typeSel,
      //   nftHash:this.nfdtSel,
      //   inputData:this.numberConverted,
      // }
      // carbonRegistry.submitProjectInfo(res => {
      //   if(res.code == 200){
          this.convertShow = true
          // this.convertCCERList = res.data
      //   }
      // },data)
      
    },
    ListingSubmit(){
      this.cntsShow = true
    },
    handleChangeType(val){
      if(val == 2){
        this.typeSel = null
      }
      if(val == 1){
        this.nfdtSel = null
      }
    },
    getprojectId(){
      let params = {
        country:this.login.country ? this.login.country : 'Indonesia'
      }
      carbonRegistry.getprojectId(response =>{
        console.log('response',response)
        if(response.code == 200){
          this.projectIdList = response.data.projectIdList
          this.nfdtList = response.data.nfdtList
        }
      },params)
    },
    
    columnStyle({ row, column, rowIndex, columnIndex}){
      if(columnIndex == 1){
        return "color:#366F67;word-break:break-word;padding-left:20px";
      }
      return "word-break:break-word;padding-left:20px";
    },
    // 定义添加逗号的方法
    addComma(num = 0) {
        return num.toString().replace(/\d+/, function(n) {
            return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        });
    },
    changeCredits(index) {
      this.creditssel = index;
    },
    changeTransactions(index) {
      this.transactionsSel = index;
    },
    changeCreditsSel(index){
      this.creditssel = index
    },
    changeTokenCarbonSel(val){
      this.tokenCarbonSel = val
      console.log(this.tokenCarbonSel)
    },
    getCountry() {
      carbonRegistry.getCountry((res) => {
        this.countryList = res.list;
        // if(this.countryList.length == 1){
        //   this.countrySel = 0
        // }
      },{country:this.login.country});
    },
    changeCountry(index) {
      this.countrySel = index;
    },
    changeProvinceState(index){
      this.provinceStateSel.push(index)
      console.log('this.provinceStateSel  change',this.provinceStateSel)
    },
    getProjectType() {
      carbonRegistry.getProjectType((res) => {
        this.typeList = res.list;
      },{country:this.login.country});
    },
    changeType(index) {
      console.log('index',index)
      this.typeSel = index;
    },
    changenfdt(index){
      this.nfdtSel = index
    },
    changeRefistryId(index){
      this.refistryIdSel = index
    },
    changecnt(index){
      this.cntAddressSel = index
    },
    getMethodology() {
      carbonRegistry.getMethodology((res) => {
        this.methodologyList = res.list;
      },{country:this.login.country});
    },
    changeMethodology(index) {
      this.methodologySel = index;
    },
    tab(index) {
      this.index = index;
    },
    //翻页
    handleCurrentChange(updateCurrentPage) {
      this.currentPage = updateCurrentPage;
    },
    handleChange(val) {
      if (val != "") {
        this.currentActiveName = val;
      }
      console.log(this.currentActiveName)
      if(val !== 4){
        this.cntsShow = false
        this.cntsNumber = ''
      }
      if(val !== 3){
        this.typeSel = null
        this.nfdtSel = null
        this.convertShow = false
        this.form = {}
      }
      if(val !== 2){
        this.listShow = false
      }
    },
    handleChangeProject(val){
      if (val != "") {
        this.active = val;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url(../../assets/css/miniBtc.css);
.mini_bg {
  width: 100%;
  height: 446px;
  background: url("../../assets/img/minibj.png") no-repeat;
  background-size: 100% 100%;
  .bg_title{
    line-height: 79px;
  }
  .xian{
    width: 79px;
    height: 10px;
    background: #ADADAD;
    opacity: 0.3;
    border-radius: 20px;
    margin: 44px 0 79px 0;
  }
}
.overview_wrap {
  background: #f8f9fa;
  padding: 45px;
  border-radius: 10px;
  .border {
    border-right: 1px solid #e5e5e5;
  }
  .title {
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #1e1e1e;
    margin-bottom: 50px;
  }
  .title_little{
    font-size: 20px;
    font-family: ArialMT;
    color: #1E1E1E;
    font-weight: bold;
  }
  
  .one {
    margin-bottom: 39px;
    .name {
      font-size: 20px;
      font-family: ArialMT;
      color: #626262;
    }
    .nums {
      text-align: right;
      font-size: 22px;
      font-family: Arial-BoldMT, Arial;
      font-weight: bold;
      color: #424242;
    }
    .num{
      text-align: left;
    }
  }
  .one:last-child {
    margin-bottom: 0;
  }
}

.projects {
  padding: 0 20px;
}
.bth-wrap {
  margin-bottom: 20px;
}
.Country {
  height: 200px;
  overflow-y: scroll;
  li {
    font-size: 14px;
    font-family: ArialMT;
    color: #41566b;
    padding: 12px 10px;
    cursor: pointer;
    margin-left: 10px;
    text-align: left;
  }
}

.Country1 {
  padding: 0 20px;
  li {
    list-style: none;
    font-size: 14px;
    font-family: ArialMT;
    color: #41566b;
    cursor: pointer;
    padding: 12px 0px;
  }
}
.overviewSel {
  color: #158869 !important;
  font-weight: bold;
}
.selbg{
  background: #F4FAF9 !important;
}

::v-deep .bth-wrap .el-button {
  padding: 0;
}
.bths {
  width: 125px;
  height: 44px;
  background: #158869;
  border-radius: 4px;
  font-size: 14px;
  font-family: ArialMT;
  color: #ffffff;
}
.bthClear {
  background: #ffffff;
  color: #158869;
  border: 1px solid #158869;
  // margin-left: 20px;
}
.aaa {
   ::v-deep .el-collapse-item__header {
    background-color: #158869 !important;
    color: #ffffff !important;
    border-radius: 10px !important;
    padding: 0 20px !important;
  }

}
.p {
  ::v-deep .el-collapse-item__header {
    padding: 0 !important;
  }
}
.projects{
  ::v-deep .el-collapse-item__header{
    background-color: #fff !important;
    color: #1e1e1e !important;
  }
}

.Tokenize{
  ::v-deep .el-collapse-item__header{
    background-color: #fff !important;
    color: #1e1e1e !important;
    padding: 0 20px !important;
    color: #41566b !important;
    font-weight: 400 !important;
  }
  ::v-deep .el-collapse-item__wrap{
    padding: 0 20px !important;
  }
  ::v-deep .el-collapse-item__header.is-active {
    color: #158869 !important;
    font-weight: bold !important;

  }
  ::v-deep .one > .el-collapse-item:nth-of-type(-n+4) .el-icon-arrow-right:before {
    content: " ";
  }
  ::v-deep .three > .el-collapse-item .el-icon-arrow-right:before {
    content: " ";
  }
  ::v-deep .three>.el-collapse-item:nth-child(2) .el-icon-arrow-right:before {
    content: "\e6e0";
  }
}
.form {
  ::v-deep .el-icon-arrow-right:first-child:before{
    content: "\e6e0";
  }
  ::v-deep .el-collapse-item__header{
    padding: 0  !important;
  }
  ::v-deep .el-collapse-item__wrap{
    padding: 0  !important;
  }
}
::v-deep .left .el-collapse-item__header.is-active {
  background-color: #158869;
  color: #ffffff;
  border-radius: 10px;
  padding: 0 12px;
}

::v-deep .projects .el-collapse-item__header.is-active {
  background-color: transparent;
  color: #158869 !important;
  padding: 0;
}

::v-deep .projects .el-collapse-item__wrap {
  // padding: 0 10px;
  border-bottom: none;
}

::v-deep .projects .el-form-item__label {
  font-size: 14px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1e1e1e;
}

::v-deep .left .el-collapse-item__content:first-child {
  padding: 0;
  border-bottom: none;
}

::v-deep .left .el-collapse-item__header {
  border: none;
  font-size: 14px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1e1e1e;
  background-color: transparent;
  // color: #ffffff;
}
::v-deep .left .el-collapse {
  border-top: none;
  border-bottom: none;
}
::v-deep .projects .el-collapse {
  border-top: none;
  border-bottom: none;
}
.data-pic {
  width: 244px;
  height: 210px;
}
.nodata {
  font-size: 16px;
  font-family: ArialMT;
  color: #626262;
}

::v-deep .el-table::before {
  height: 0px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #f4f4f5;
    color: #158869;
}

::v-deep .el-collapse-item__wrap{
  border: none !important;
}

::v-deep .el-table .cell{
  word-break: break-word;
}

::v-deep .el-table{
  border-radius: 10px 10px 0 0;
}

.upload{
  width: 167px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #158869;
  font-size: 14px;
  font-family: ArialMT;
  color: #158869;
}
.cancel{
  width: 125px;
  height: 44px;
  background: #158869;
  border-radius: 4px;
  font-size: 16px;
  font-family: ArialMT;
  color: #FFFFFF;
}
.confirm{
  background-color: #ffffff;
  color: #158869;
  border: 1px solid #158869;
}
::v-deep .el-button{
  padding: 0;
}

::v-deep .newProject .el-form-item__label{
  font-size: 16px;
  font-family: ArialMT;
  color: #626262;
}

::v-deep .Country{
  .el-checkbox__inner{
    display: none;
  }
  .el-checkbox-group{
    width: 100%;
  }
  .el-checkbox{
    width: 100%;
    font-size: 14px;
    font-family: ArialMT;
    color: #41566b;
    padding: 12px 0px;
    margin-right: 0;
  }
  .is-checked{
    font-weight: bold;
    background: #F4FAF9 !important;
  }
  .el-checkbox__label{
    padding-left: 0;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #158869  !important;
  }
}
.map_box{
    width: 100%;
    height: 457px;
    // background: pink;
}

::v-deep .TokenizeCarbon>.one > .el-collapse-item:nth-of-type(-n+4) .el-icon-arrow-right:before {
    content: " ";
}

.Tokenize_title{
  font-size: 24px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1E1E1E;
  margin-bottom: 28px;
}
.Tokenize_title_item{
  font-size: 20px;
  font-family: ArialMT;
  color: #626262;
  margin: 10px 10px 10px 28px
}
.btn_wrap{
  width: 167px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #158869;
  font-size: 14px;
  font-family: ArialMT;
  color: #158869;
}
.btn_submit{
  background: #158869;
  color: #ffffff;
  word-break: break-word;
}
.btn_pending{
  background: #7CC0D3 ;
  border: none;
  color: #ffffff;
}
.selects{
  font-size: 20px;
  font-family: ArialMT;
  color: #626262;
}
::v-deep .convertWrap{
  width: 253px;
  height: auto;
  background: #FFFFFF;
  border-radius: 4px;
  .el-collapse{
    border: none;
  }
  .el-collapse-item__header{
    border: none;
     padding: 0 10px;
  }
  .el-collapse-item__header.is-active{
    color: #158869 !important;
    font-weight: bold;
  }
  
}

.cntid{
  font-size: 20px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #626262;
  span{
    font-weight: 400;
  }
}
::v-deep .el-step__description{
    margin-top:10px;
    font-size: 16px;
    padding-left: 10%;
    padding-right: 10%;
    line-height: 24px;
    color: #626262;
}
::v-deep .el-step__line-inner{
    background-color: #158869;
}
::v-deep .el-step__head.is-success{
    color: #158869;
    border-color: #158869;
}

::v-deep .is-success {
    .el-step__icon.is-text{
        background-color: #158869;
        color: #ffffff;
    }
    
}
::v-deep .el-step__description.is-success{
    color: #158869;
}
::v-deep .el-step__description.is-process{
    color: #626262;
}
::v-deep .is-process{
    .el-step__icon.is-text{
        background-color: #FFFFFF;
        color: #C0C4CC;
        border-color: #C0C4CC;
    }
}

.steps{
  padding: 20px;
  background: #FFFFFF;
  border-radius: 21px;
  margin-top: 37px;
  
}
.step{
  padding: 33px 0;
  border-bottom: 1px solid #E5E5E5;
  font-size: 20px;
  font-family: ArialMT;
  color: #134475;
  .step_nums{
    font-weight: bold;
    margin-bottom: 18px;
  }
  
}
.step_four{
  color: #626262;
}

.complete{
  font-size: 14px;
  font-family: ArialMT;
  color: #158869;
  margin-right: 20px;
}

</style>
